import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'

interface IPrimaryLinkProps {
  inlineText: boolean
  disabled: boolean
  theme: ITheme
}

export const PrimaryLink = styled('a')<IPrimaryLinkProps>`
  color: ${(props) =>
    props.inlineText ? 'inherit' : props.theme.colors.primary};
  font-weight: ${(props) =>
    props.inlineText ? 'inherit' : props.theme.font.weight.bold};
  color: ${(props) => props.disabled && '#cccccc'};
  text-decoration: underline;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    color: ${(props) => props.disabled && '#cccccc'};
  }
`
